import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   GET_SALE_CHALLAN,
   ADD_SALE_CHALLAN,
   UPDATE_SALE_CHALLAN,
   GET_SALE_CHALLAN_BY_ID,
   DELETE_SALE_CHALLAN,
   GET_LAST_SALE_CHALLAN_DAYBOOK,
   DELETE_MULTI_SALES_CHALLAN,
} from '../types';

export const addSaleChallan = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/sales-challan/add`, formData);
      if (res.data.code === 1) {
         dispatch({
            type: ADD_SALE_CHALLAN,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
         setTimeout(() => {
            toast.success('Sale Challan added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err?.response?.data?.message);
         return err?.response?.data;
      }
   }
};


export const getSaleChallan = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/sales-challan/all`, { params });
      if (res.data.code === 1) {
         dispatch({
            type: GET_SALE_CHALLAN,
            payload: {
               data: res.data.data,
               pagination: res.data.pagination,
            },
         });
      }
   } catch (err) {
      console.error('getSaleInvoices err', err);
   }
};

// export const getSaleInvoicesForDaybook = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/sales-invoice/all`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_SALE_INVOICES_FOR_DAYBOOK,
//             payload: {
//                data: res.data.data,
//                pagination: res.data.pagination,
//             },
//          });
//       }
//    } catch (err) {
//       console.error('getSaleInvoices err', err);
//    }
// };

// export const getSaleInvoicestransactions = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/sales-invoice/all`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_SALE_INVOICES_TRANSACTIONS,
//             payload: {
//                data: res.data.data,
//                pagination: res.data.pagination,
//             },
//          });
//       }
//    } catch (err) {
//       console.error('getSaleInvoices err', err);
//    }
// };

// Get Single SaleInvoice
export const getSaleChallanById = (id) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.get(`/sales-challan/${id}`);
      if (res.data.code === 1) {
         dispatch({
            type: GET_SALE_CHALLAN_BY_ID,
            payload: res.data.data,
            totalCount: res.data.totalCount,
         });
      }
   } catch (err) {
      console.error('getSaleInvoice err', err);
   }
};

// // Get Last Sale Daybook
export const getLastSaleChallanDaybook = (params) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      // const res = await axios.get(`/sales/last`, { params });
      const res = await axios.get(`/sales-challan/lastDocNo`, { params });
      if (res.data.code === 1) {
         dispatch({ type: GET_LAST_SALE_CHALLAN_DAYBOOK, payload: res.data.data });
         return res.data.data;
      }
   } catch (err) {
      console.error('getLastSaleDaybook err', err);
   }
};

export const updateSaleChallan = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post(`/sales-challan/update`, formData);
      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SALE_CHALLAN, payload: res.data.data });
         setTimeout(() => {
            toast.success('Sale Challan updated successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
         return res.data;
      }
      return res.data;
   } catch (err) {
      if (err.response?.data?.message) {
         toast.error(err.response?.data?.message);
      }
      return err.response?.data;
   }
};

// // Last Bill Sale Invoice
// export const lastBillSaleInvoice = (params) => async (dispatch) => {
//    try {
//       const res = await axios.get(`/sales/last-billNo`, {
//          params,
//       }); //pass Daybook ID
//       if (res.data.code === 1) {
//          dispatch({
//             type: LAST_BILL_SALE_INVOICE,
//             payload: res.data.data,
//          });
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };
// Delete Sale Invoice
export const deleteSaleChallan = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.warn('Please select any record', 'warning');
         return false;
      }
      const res = await axios.post(`/sales-challan/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_SALE_CHALLAN, payload: { id } });
         setTimeout(() => {
            toast.success('Sale Challan deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err?.response?.data?.message) {
         toast.error(err?.response?.data?.message);
      }
   }
};

// export const deleteSaleInvoice = (id, outAdjustmentIds = null) => async (dispatch) => {
//    try {
//       if (!id) {
//          toast.warn('Please select any record', 'warning');
//          return false;
//       }

//       let res;

//       // If outAdjustmentIds are provided, send them in the request body
//       if (outAdjustmentIds && outAdjustmentIds.length > 0) {
//          // Send outAdjustmentIds in request body
//          res = await axios.post(`/sales-invoice/delete/${id}`, {
//             outAdjustmentIds: outAdjustmentIds,
//          });
//       } else {
//          // Normal deletion without body data
//          res = await axios.post(`/sales-invoice/delete/${id}`);
//       }

//       if (res.data.code === 1) {
//          dispatch({ type: DELETE_SALE_INVOICE, payload: { id } });
//          setTimeout(() => {
//             toast.success(res.data.message);
//          }, 1000);
//       }

//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err?.response?.data?.message) {
//          toast.error(err?.response?.data?.message);
//       }
//    }
// };

// export const getSingleSaleInvoice = (id) => async (dispatch) => {
//    try {
//       const res = await axios.get(`/sales-invoice/${id}`);
//       if (res.data.code === 1) {
//          dispatch({ type: GET_ONE_SALE_INVOICE, payload: res.data.data });
//       }
//    } catch (err) {
//       console.error('Failed to get item by finish item. Please try again.');
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };

// export const getSingleWithPrevAndNext = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/sales-invoice/all`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_SALE_INVOICE_WITH_PREV_AND_NEXT,
//             payload: res.data,
//             // payload: res.data.data,
//             // totalCount: res.data.totalCount,
//          });
//       }
//    } catch (err) {
//       console.error('getSaleInvoices err', err);
//    }
// };

// export const getPrevAndNext = (params) => async (dispatch) => {
//    try {
//       const res = await axios.get(`/sales-invoice/prev-next`, { params });
//       if (res.data.code === 1) {
//          dispatch({ type: GET_SALE_INVOICE_PREV_AND_NEXT, payload: res.data.data });
//       }
//       return res.data.data;
//    } catch (err) {
//       console.error('getSaleInvoices err', err);
//    }
// };

// export const emptySales = () => async (dispatch) => {
//    console.log('reset...');
//    dispatch({ type: EMPTY_ONE_SALE_INVOICE, payload: null });
// };

// export const getPendingVoucherSalesAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-voucher-with-sales-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PENDING_VOUCHER_SALES_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getPendingSalesAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-sales-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PENDING_SALES_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getPendingPurchaseAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-purchase-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PURCHASE_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getPendingVoucherWithPurchaseAdjustment = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/unadjusted/pending-voucher-with-purchase-adjustments`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_PENDING_VOUCHER_WITH_PURCHASE_ADJUSTMENT,
//             payload: res.data.data,
//          });
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const getAdjustedDocs = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get(`/sales-invoice/adjustmentDocument`, { params });
//       if (res.data.code === 1) {
//          dispatch({
//             type: GET_ADJUSTED_DOCS,
//             payload: res.data.data,
//          });
//          return res.data;
//       }
//    } catch (error) {
//       console.error(error);
//    } finally {
//       dispatch({ type: 'SET_LOADING', payload: false });
//    }
// };

// export const deleteAdjustedDocs = (id) => async (dispatch) => {
//    try {
//       if (!id) {
//          toast.warn('Please select any record', 'warning');
//          return false;
//       }
//       const res = await axios.post(`/outAdjustment/delete/${id}`);
//       if (res.data.code === 1) {
//          dispatch({ type: DELETE_ADJUSTED_DOCS, payload: { id } });
//          return res.data;
//          setTimeout(() => {
//             toast.success('Adjusted document deleted successfully!');
//          }, 1000);
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err?.response?.data?.message) {
//          toast.error(err?.response?.data?.message);
//       }
//    }
// };

export const checkDocNo = (data) => async (dispatch) => {
   try {
      const res = await axios.post('/sales-challan/checkDocNo', data);
      if (res.data.code === 1) {
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (error) {
      if (error?.response?.data?.message) {
         toast.error(error?.response?.data?.message);
      }
   }
};

// export const getLastSaleDaybooByCompanyId = (companyId) => async (dispatch, getState) => {
//    try {
//       const res = await axios.get(`/sales-invoice/lastDaybook`, { params: { companyId } });
//       if (res.data.code === 1) {
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (error) {
//       if (error?.response?.data?.message) {
//          toast.error(error?.response?.data?.message);
//       }
//    }
// };

// export const getLastSaleDocNo = (params) => async (dispatch, getState) => {
//    try {
//       const res = await axios.get(`/sales-invoice/lastDocNo`, { params: params });
//       if (res.data.code === 1) {
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (error) {
//       if (error?.response?.data?.message) {
//          toast.error(error?.response?.data?.message);
//       }
//    }
// };

// export const getItemPrice = (params) => async (dispatch) => {
//    try {
//       const res = await axios.get('/sales-invoice/itemPrice', { params: params });
//       if (res.data.code === 1) {
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//       return res.data;
//    } catch (error) {
//       if (error?.response?.data?.message) {
//          toast.error(error?.response?.data?.message);
//       }
//    }
// };

// export const uploadSalesDocument = (formData) => async (dispatch) => {
//    try {
//       const res = await axios.post('/sales-invoice/addImg', formData, {
//          headers: {
//             'Content-Type': 'multipart/form-data',
//          },
//       });
//       if (res.data.code === 1) {
//          dispatch({ type: UPDATE_SALES_DOC, payload: res.data.data });
//          toast.success(res.data.message);
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          toast.warn(res.data.message);
//       }
//    } catch (err) {
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };

// export const deleteSalesDocument = (formData) => async (dispatch) => {
//    try {
//       const res = await axios.post('/sales-invoice/deleteImg', formData, {
//          headers: {
//             'Content-Type': 'multipart/form-data',
//          },
//       });
//       if (res.data.code === 1) {
//          dispatch({ type: DELETE_SALES_DOC, payload: res.data.data });
//          toast.success(res.data.message);
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          toast.warn(res.data.message);
//       }
//    } catch (err) {
//       if (err.response.data.message) {
//          toast.error(err.response.data.message);
//       }
//    }
// };

export const deleteMultiSalesChallan = (formData) => async (dispatch) => {
   try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const res = await axios.post("/sales-challan/delete/multi", formData);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_MULTI_SALES_CHALLAN, payload: res.data.data });
         setTimeout(() => {
            toast.success('Sales Challan deleted successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data?.message) {
         toast.error(err.response?.data?.message);
      }
   }
};

// export const partyServiceBlock = (formData) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.post("/sales-invoice/partyServiceBlock", formData);
//       if (res.data.code === 1) {
//          dispatch({ type: PARTY_SERVICE_BLOCK, payload: res.data.data });
//          setTimeout(() => {
//             toast.success(res?.data?.message);
//          }, 1000);
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err.response.data?.message) {
//          toast.error(err.response?.data?.message);
//       }
//    }
// };

// export const getStoreSales = (params) => async (dispatch) => {
//    try {
//       dispatch({ type: 'SET_LOADING', payload: true });
//       const res = await axios.get("/sales-invoice/storeSales", { params });
//       if (res.data.code === 1) {
//          dispatch({ type: GET_STORE_SALES, payload: res.data.data });
//          return res.data;
//       }
//       if (res.data.code === 2) {
//          setTimeout(() => {
//             toast.warn(res.data.message);
//          }, 1000);
//       }
//    } catch (err) {
//       if (err.response.data?.message) {
//          toast.error(err.response?.data?.message);
//       }
//    }
// };